import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiClock, FiVideo, FiCheckCircle } = FiIcons;

const BookDemo = () => {
  return (
    <div className="pt-24 pb-20 bg-brand-ivory min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h1 className="text-5xl font-display font-bold text-brand-indigo mb-6">See HDAI in Action</h1>
            <p className="text-xl text-brand-slate mb-12 leading-relaxed">
              Schedule a personalized walkthrough with our clinical solutions team. We'll show you how to digitize your workflows and ensure complete HIPAA compliance.
            </p>
            
            <div className="space-y-8">
              {[
                { title: "Personalized Walkthrough", desc: "A 30-minute deep dive into your specific clinical use case.", icon: FiVideo },
                { title: "Architecture Review", desc: "Consult with our engineers on how HDAI fits into your IT stack.", icon: FiClock },
                { title: "Compliance Briefing", desc: "Learn about our FDA and HIPAA validation frameworks.", icon: FiCheckCircle }
              ].map((item, i) => (
                <div key={i} className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-brand-mint/20 rounded-xl flex items-center justify-center shrink-0">
                    <SafeIcon icon={item.icon} className="text-brand-indigo" />
                  </div>
                  <div>
                    <h4 className="font-bold text-brand-indigo">{item.title}</h4>
                    <p className="text-sm text-brand-slate">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white p-10 rounded-[2.5rem] border border-gray-100 shadow-2xl"
          >
            <div className="mb-10 text-center">
              <div className="w-16 h-16 bg-brand-indigo rounded-2xl flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiCalendar} className="text-brand-mint text-2xl" />
              </div>
              <h3 className="text-2xl font-bold text-brand-indigo">Book a Demo</h3>
            </div>

            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-widest">Full Name</label>
                  <input type="text" className="w-full bg-gray-50 border-gray-200 rounded-xl px-4 py-3 focus:ring-brand-mint" placeholder="Dr. Sarah Smith" />
                </div>
                <div className="space-y-2">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-widest">Work Email</label>
                  <input type="email" className="w-full bg-gray-50 border-gray-200 rounded-xl px-4 py-3 focus:ring-brand-mint" placeholder="sarah@hospital.org" />
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-widest">Organization Type</label>
                <select className="w-full bg-gray-50 border-gray-200 rounded-xl px-4 py-3 focus:ring-brand-mint">
                  <option>Large Health System</option>
                  <option>Private Practice</option>
                  <option>Health-Tech Startup</option>
                  <option>Research Institution</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-widest">Primary Interest</label>
                <textarea className="w-full h-32 bg-gray-50 border-gray-200 rounded-xl px-4 py-3 focus:ring-brand-mint" placeholder="Tell us what you're looking to build..."></textarea>
              </div>
              <button className="w-full bg-brand-indigo text-white py-4 rounded-2xl font-bold hover:bg-brand-slate transition-all shadow-lg hover:shadow-xl">
                Request Walkthrough
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default BookDemo;